module.exports = __webpack_public_path__ + "img/meter.dd70268c.png";